module.exports = __webpack_public_path__ + "img/exoskeleton-equipment.d3a5c9e7.png";